import { call } from 'typed-redux-saga/macro';

import { withErrorHandling } from 'Lib/sagaHelpers';

import { ASYNC_FEATURE_NOTIFICATIONS, loadAsyncBundle } from 'Store/asyncSaga';

export function* _avSaga() {
  yield* call(loadAsyncBundle, ASYNC_FEATURE_NOTIFICATIONS);
}

export const avSaga = withErrorHandling(_avSaga, {
  name: 'avSaga',
});
